const getInitialCustomSpotStep = (isCustom, spotStep) => {
  if (!isCustom) return ''
  return spotStep % 60 === 0 ? (spotStep / 60).toString() : spotStep.toString()
}

export const getInitialValues = ({
  spot_step: spotStep,
}) => {
  const isCustomSpotStep = ![5, 10, 15, 20, 30, 45, 60].includes(spotStep)

  return {
    spotStep: !isCustomSpotStep ? spotStep : 'custom',
    customSpotStep: getInitialCustomSpotStep(isCustomSpotStep, spotStep),
    customSpotStepType: isCustomSpotStep && spotStep % 60 === 0 ? 'hours' : 'minutes',
  }
}
